import { render } from "./list.vue?vue&type=template&id=2c277c6a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=2c277c6a&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c277c6a"]])

export default __exports__